import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import useSWR, { mutate } from 'swr'
import usePermissions from 'hooks/usePermissions'

export default withTranslation()(function Header({ t }) {
  // const {data: stats} = useSWR('pos/get-mobile-app-dashboard-stats')

  const { data: stats } = useSWR('/merchants/stats/total-revenues')
  // const { merchant } = useSelector(state => state.SettingsReducer)
  const { response } = useSelector(state => state?.misc)
  // console.log(stats?.data, 'hdhdhdhie');
  const { isPermitted } = usePermissions()
  useEffect(() => { mutate('pos') }, [response])

  return (
    <div className="w-full bg-white p-3 md:p-8 flex flex-col lg:flex-row mb-8 rounded-xl">
      <div className="w-full flex justify-between items-center my-2">
        {isPermitted?.view_pos_revenue ?
          <>
            <div className="col-span-2">
              <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.total_revenues}</h4>
              <p className="text-sm">{t('misc.total_revenue')}</p>
            </div>
          </>
          : 'Not permitted'}

        <div className="text-center">
          <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.pos_count}</h4>
          <p className="text-sm">{t('pos.pos')}</p>
        </div>

        <div className="col-span-2">
          <h4 className="lg:text-lg xs:text-sm font-semibold md:text-2xl">{stats?.data?.total_transactions}</h4>
          <p className="text-sm">{t('misc.total_transaction')}</p>
        </div>
      </div>
    </div>
  )
})